import 'phaser'
import {
    CST
} from '../CST'

export default class End extends Phaser.Scene {
    constructor() {
        super(CST.SCENES.END)
    }

    preload() {}

    create(data) {
        var clickSound = this.sound.add("click-sound");
        this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'questionnaire-bg');
        this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'thanks-popUp').setScale(.8)

        this.feedback = this.add.image(this.cameras.main.width / 2 /*- 150*/ , (this.cameras.main.height / 2 + 200), 'menu-btn').setScale(1.5).setInteractive({
            useHandCursor: true
        }).on("pointerdown", () => {
            clickSound.play();
            window.location.reload();
        });
    }
}